import { createFileRoute } from "@tanstack/react-router";
import { AdminExportsPage } from "@/projects/admin/pages/ExportsPage";

export const Route = createFileRoute("/admin/exports")({
  head: () => ({ meta: [{ title: "Export History — Admin" }] }),
  component: AdminExportsPage,
});
